import { ReactNode, useReducer } from 'react';
import IconButton from 'components/Shared/Buttons/IconButton';
import PlusIcon from 'components/Shared/SearchFilter/PlusIcon';
import classNames from 'classnames';
import { camelCase } from 'lib/utils';
import styles from './styles';

interface AccordionProps {
  title: string;
  children?: ReactNode;
  expanded?: boolean;
  onClick?: (isExpanding: boolean) => Promise<void>;
}

function Accordion({
  title,
  children,
  expanded: initialExpanded,
  onClick,
}: AccordionProps): JSX.Element {
  const [isExpanded, toggle] = useReducer((expanded) => !expanded, !!initialExpanded);

  function onClickToggle(): void {
    onClick?.(!isExpanded);
    toggle();
  }

  const accordionSummaryId = `filter-container-summary-${camelCase(title)}`;
  const accordionDetailId = `filter-container-details-${camelCase(title)}`;

  return (
    <>
      <div className="accordion">
        <div
          className="accordion-summary"
          onClick={onClickToggle}
          id={accordionSummaryId}
          data-testid="accordion-toggle"
        >
          <div className="filter-title">{title}</div>
          <IconButton
            className="filter-container-icon-button"
            style={{
              margin: 0,
              padding: 0,
              textTransform: 'none',
              boxSizing: 'unset',
              backgroundColor: 'transparent',
              display: 'contents',
            }}
            onMouseOver={(e): void => {
              e.currentTarget.style.backgroundColor = '#EBEBEB';
            }}
            aria-controls={accordionDetailId}
            aria-label="expand-toggle"
            aria-haspopup="true"
            aria-expanded={isExpanded ? 'true' : undefined}
          >
            <PlusIcon isRotated={isExpanded} />
          </IconButton>
        </div>
        <div
          className={classNames('accordion-content', {
            collapsed: !isExpanded,
          })}
        >
          {children}
        </div>
      </div>
      <style jsx>{styles}</style>
    </>
  );
}

export default Accordion;
